export default __webpack_public_path__ + "static/media/less-cramping-ON.c394604e.png";